import { css } from "lit";

export const previewModeStyles = css`
  /* Disable interactive elements in preview mode */
  :host([preview-mode]) button:not(.preview-allow),
  :host([preview-mode]) a:not(.preview-allow),
  :host([preview-mode]) [role="button"]:not(.preview-allow),
  :host([preview-mode]) input:not(.preview-allow),
  :host([preview-mode]) select:not(.preview-allow) {
    pointer-events: none;
    cursor: default;
  }

  /* Specific elements to disable */
  :host([preview-mode]) .menu-button,
  :host([preview-mode]) .subscribe-button,
  :host([preview-mode]) .tab-navigation,
  :host([preview-mode]) .social-links,
  :host([preview-mode]) .navigation-hamburger,
  :host([preview-mode]) menu-button,
  :host([preview-mode]) notification-bell {
    pointer-events: none;
  }

  /* Allow scrolling and specific interactions */
  :host([preview-mode]) .scroll-container,
  :host([preview-mode]) .preview-allow {
    pointer-events: auto;
  }

  /* Keep visual feedback but disable interaction */
  :host([preview-mode]) .link-card,
  :host([preview-mode]) .discount-card,
  :host([preview-mode]) .exclusive-highlight {
    pointer-events: none;
  }
`;
